import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
export default function ObjectionsSection() {
  const faqs = [{
    q: '«¿Y si tomo pastillas para dormir?»',
    a: 'El protocolo funciona igual. De hecho, está diseñado para ayudarte a dejarlas gradualmente (si eso es lo que quieres) al reducir tu ansiedad nocturna.'
  }, {
    q: '«¿Cuánto tiempo tarda en funcionar?»',
    a: 'Muchos sienten alivio desde la primera noche al aplicar la técnica de "descarga mental". El protocolo completo dura 14 días para consolidar el hábito.'
  }, {
    q: '«¿Es una meditación guiada?»',
    a: 'No. Es un sistema cognitivo para "apagar" el interruptor de alerta de tu cerebro. Incluye un audio de emergencia, pero el núcleo es cambiar tu relación con la cama.'
  }, {
    q: '«¿Necesito mucho tiempo?»',
    a: 'No. Solo necesitas leer 10 minutos al día y aplicar las técnicas por la noche. Está diseñado para gente cansada y ocupada.'
  }, {
    q: '«¿Y si me despierto en la madrugada?»',
    a: 'Para eso es el Audio de Emergencia "SOS Madrugada". Te guía paso a paso para volver a dormir sin frustrarte.'
  }, {
    q: '«¿Qué pasa si no me funciona?»',
    a: 'Tienes 7 días de garantía. Si sientes que no es para ti, te devolvemos tu dinero sin preguntas.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <Section className="bg-brand-charcoal" data-id="element-234">
      <h2 className="font-heading text-4xl text-white text-center mb-12 uppercase tracking-wide" data-id="element-235">
        Preguntas típicas
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-236">
        {faqs.map((faq, index) => <div key={index} className="border border-white/10 rounded-lg overflow-hidden bg-brand-dark shadow-sm group hover:border-brand-indigo/30 transition-colors" data-id="element-237">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left focus:outline-none hover:bg-white/5 transition-colors" data-id="element-238">
              <span className="text-xl font-medium text-slate-200 pr-4 group-hover:text-white transition-colors" data-id="element-239">
                {faq.q}
              </span>
              <ChevronDown className={`text-brand-indigo transition-transform duration-200 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-240" />
            </button>
            <AnimatePresence data-id="element-241">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.2
          }} data-id="element-242">
                  <div className="p-6 pt-0 text-lg text-slate-400 border-t border-white/5 leading-relaxed flex gap-4" data-id="element-243">
                    <CheckCircle2 className="text-brand-indigo flex-shrink-0 mt-1" size={20} data-id="element-244" />
                    <span data-id="element-245">{faq.a}</span>
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
    </Section>;
}